module.exports = __webpack_public_path__ + "static/Infographic4_4_Taichung-eccbc30527790f52f6a89de29b5cbd28.png";